import W from "./atoms-v21165.js";
import A from "./atoms-v21166.js";
import * as h from "react";
import I from "./atoms-v21167.js";
import k from "./atoms-v21168.js";
var H = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0"
}, B = function(t) {
  Object.keys(H).forEach(function(r) {
    t.style.setProperty(r, H[r], "important");
  });
}, L = B, n = null, R = function(t, r) {
  var e = t.scrollHeight;
  return r.sizingStyle.boxSizing === "border-box" ? e + r.borderSize : e - r.paddingSize;
};
function M(i, t, r, e) {
  r === void 0 && (r = 1), e === void 0 && (e = 1 / 0), n || (n = document.createElement("textarea"), n.setAttribute("tabindex", "-1"), n.setAttribute("aria-hidden", "true"), L(n)), n.parentNode === null && document.body.appendChild(n);
  var o = i.paddingSize, u = i.borderSize, a = i.sizingStyle, c = a.boxSizing;
  Object.keys(a).forEach(function(v) {
    var p = v;
    n.style[p] = a[p];
  }), L(n), n.value = t;
  var d = R(n, i);
  n.value = t, d = R(n, i), n.value = "x";
  var g = n.scrollHeight - o, s = g * r;
  c === "border-box" && (s = s + o + u), d = Math.max(s, d);
  var f = g * e;
  return c === "border-box" && (f = f + o + u), d = Math.min(f, d), [d, g];
}
var w = function() {
}, N = function(t, r) {
  return t.reduce(function(e, o) {
    return e[o] = r[o], e;
  }, {});
}, _ = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak"
], $ = !!document.documentElement.currentStyle, j = function(t) {
  var r = window.getComputedStyle(t);
  if (r === null)
    return null;
  var e = N(_, r), o = e.boxSizing;
  if (o === "")
    return null;
  $ && o === "border-box" && (e.width = parseFloat(e.width) + parseFloat(e.borderRightWidth) + parseFloat(e.borderLeftWidth) + parseFloat(e.paddingRight) + parseFloat(e.paddingLeft) + "px");
  var u = parseFloat(e.paddingBottom) + parseFloat(e.paddingTop), a = parseFloat(e.borderBottomWidth) + parseFloat(e.borderTopWidth);
  return {
    sizingStyle: e,
    paddingSize: u,
    borderSize: a
  };
}, P = j;
function C(i, t, r) {
  var e = I(r);
  h.useLayoutEffect(function() {
    var o = function(a) {
      return e.current(a);
    };
    if (i)
      return i.addEventListener(t, o), function() {
        return i.removeEventListener(t, o);
      };
  }, []);
}
var O = function(t) {
  C(window, "resize", t);
}, Y = function(t) {
  C(document.fonts, "loadingdone", t);
}, G = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], X = function(t, r) {
  var e = t.cacheMeasurements, o = t.maxRows, u = t.minRows, a = t.onChange, c = a === void 0 ? w : a, d = t.onHeightChange, g = d === void 0 ? w : d, s = A(t, G), f = s.value !== void 0, v = h.useRef(null), p = k(v, r), z = h.useRef(0), S = h.useRef(), m = function() {
    var l = v.current, x = e && S.current ? S.current : P(l);
    if (x) {
      S.current = x;
      var y = M(x, l.value || l.placeholder || "x", u, o), b = y[0], F = y[1];
      z.current !== b && (z.current = b, l.style.setProperty("height", b + "px", "important"), g(b, {
        rowHeight: F
      }));
    }
  }, E = function(l) {
    f || m(), c(l);
  };
  return h.useLayoutEffect(m), O(m), Y(m), /* @__PURE__ */ h.createElement("textarea", W({}, s, {
    onChange: E,
    ref: p
  }));
}, K = /* @__PURE__ */ h.forwardRef(X);
export {
  K as default
};
